<template>
    <div class="slider-item-content html" :style="styles">
        <div v-html="content.html"></div>
    </div>
</template>

<script>
export default {
    name: 'DiamondHtml',
    components: {
    },
    props: {
        content: {
            type: Object,
            default: null,
        },
        borderWidth: null
    },
    data() {
        return {
        }
    },
    computed: {
        styles(){
            let styles = {};
            if(this.borderWidth){
                styles['border-width'] = borderWidth + 'px';
            }
            return styles;
        }
    },
    watch: {
    },
    created() {
    },
    mounted() {
    },
    methods: {
    }
};
</script>

<style scoped>

</style>